module.exports = "<p>\r\n  smslogs works!\r\n</p>\r\n"